import { AuthenticationMethod } from './enums/AuthenticationMethod'
import AuthenticationJson from './interfaces/AuthenticationJson'

export default class Authentication {
  method: AuthenticationMethod
  type: string
  code: string

  constructor(method: AuthenticationMethod, type: string, code: string) {
    this.method = method
    this.type = type
    this.code = code
  }

  static fromJson(data: AuthenticationJson) {
    return new this(data.method, data.type, data.code)
  }
}
